

import { createSlice } from "@reduxjs/toolkit";
import { getHouseAllocation, getAllSimulations, getSimulationById, assignTransfers, unAssignTransfers, getLocationsForSimulationCalendar, moveOutTransfers, acceptTransfers, moveBackTransfers, moveUpdateTransfers, deleteSimulationById } from "../actions/nycha";
import { logoutUser } from "../actions/account";

const initialState = {
    error: false,
    selectedClientAndLocationResources: {
        "client": [],
        "location": [],
        "goal": []
    },
    isLoadingHouseAllocation: false,
    allocatedData: [],
    isLoadingAllSimulations: false,
    allSimulations: {},
    isLoadingGetSimulationById: false,
    isLoadingAssignTransfers:false,
    isLoadingUnAssingTransfers:false,
    isLoadingGetLocationsForSimulationCalendar:false,
    isLoadingMoveOutTransfers:false,
    isLoadingMoveBackTransfers:false,
    isLoadingMoveUpdateTransfers:false,
    isLoadingAcceptTransfers:false,
    locationsForSimulationCalendar:[],
    isLoadingDeleteSimulationById:false,
};

const nychaSlice = createSlice({
    name: "nycha",
    initialState,
    reducers: {
        "account/logoutUser": (state) => initialState,
        storeNychaResources(state, action) {
            if (action?.payload?.client) {
                state.selectedClientAndLocationResources = Object.assign({}, state.selectedClientAndLocationResources, {
                    "client": action.payload?.client
                });
            } else if (action?.payload?.location) {
                state.selectedClientAndLocationResources = Object.assign({}, state.selectedClientAndLocationResources, {
                    "location": action.payload?.location
                });
            } else if (action?.payload?.goal) {
                state.selectedClientAndLocationResources = Object.assign({}, state.selectedClientAndLocationResources, {
                    "goal": action.payload?.goal
                });
            }
        },
        storeNychaResourcesFromSimulation(state, action) {
            state.selectedClientAndLocationResources = action?.payload?.data
        },
        clearNychaResources(state, action) {
            state.selectedClientAndLocationResources = {
                "client": [],
                "location": [],
                "goal": []
            }
        }

    },
    extraReducers: {
        [getHouseAllocation.pending]: (state, action) => {
            state.isLoadingHouseAllocation = true;
            state.error = false;
        },
        [getHouseAllocation.fulfilled]: (state, action) => {
            state.isLoadingHouseAllocation = false;
            state.allocatedData = action.payload.data;
            state.error = false;
        },
        [getHouseAllocation.rejected]: (state, action) => {
            state.isLoadingHouseAllocation = false;
            state.error = true;
        },//getAllSimulations
        [getAllSimulations.pending]: (state, action) => {
            state.isLoadingAllSimulations = true;
            state.error = false;
        },
        [getAllSimulations.fulfilled]: (state, action) => {
            state.isLoadingAllSimulations = false;
            state.allSimulations = action?.payload?.data;
            state.error = false;
        },
        [getAllSimulations.rejected]: (state, action) => {
            state.isLoadingAllSimulations = false;
            state.error = true;
        },//getSimulationById
        [getSimulationById.pending]: (state, action) => {
            state.isLoadingGetSimulationById = true;
            state.error = false;
        },
        [getSimulationById.fulfilled]: (state, action) => {
            state.isLoadingGetSimulationById = false;
            state.allocatedData = action?.payload?.data;
            state.error = false;
        },
        [getSimulationById.rejected]: (state, action) => {
            state.isLoadingGetSimulationById = false;
            state.error = true;
        },
        [assignTransfers.pending]: (state, action) => {
            state.isLoadingAssignTransfers = true;
            state.error = false;
        },
        [assignTransfers.fulfilled]: (state, action) => {
            state.isLoadingAssignTransfers = false;
            state.error = false;
        },
        [assignTransfers.rejected]: (state, action) => {
            state.isLoadingAssignTransfers = false;
            state.error = true;
        },
        [unAssignTransfers.pending]: (state, action) => {
            state.isLoadingUnAssingTransfers = true;
            state.error = false;
        },
        [unAssignTransfers.fulfilled]: (state, action) => {
            state.isLoadingUnAssingTransfers = false;
            state.error = false;
        },
        [unAssignTransfers.rejected]: (state, action) => {
            state.isLoadingUnAssingTransfers = false;
            state.error = true;
        },

        [getLocationsForSimulationCalendar.pending]: (state, action) => {
            state.isLoadingGetLocationsForSimulationCalendar = true;
            state.error = false;
        },
        [getLocationsForSimulationCalendar.fulfilled]: (state, action) => {
            state.locationsForSimulationCalendar=action?.payload?.data?.locations
            state.isLoadingGetLocationsForSimulationCalendar = false;
            state.error = false;
        },
        [getLocationsForSimulationCalendar.rejected]: (state, action) => {
            state.isLoadingGetLocationsForSimulationCalendar = false;
            state.error = true;
        },
        [acceptTransfers.pending]: (state, action) => {
            state.isLoadingAcceptTransfers = true;
            state.error = false;
        },
        [acceptTransfers.fulfilled]: (state, action) => {
            state.isLoadingAcceptTransfers = false;
            state.error = false;
        },
        [acceptTransfers.rejected]: (state, action) => {
            state.isLoadingAcceptTransfers = false;
            state.error = true;
        },
        [moveOutTransfers.pending]: (state, action) => {
            state.isLoadingMoveOutTransfers = true;
            state.error = false;
        },
        [moveOutTransfers.fulfilled]: (state, action) => {
            state.isLoadingMoveOutTransfers = false;
            state.error = false;
        },
        [moveOutTransfers.rejected]: (state, action) => {
            state.isLoadingMoveOutTransfers = false;
            state.error = true;
        },
        [moveBackTransfers.pending]: (state, action) => {
            state.isLoadingMoveBackTransfers = true;
            state.error = false;
        },
        [moveBackTransfers.fulfilled]: (state, action) => {
            state.isLoadingMoveBackTransfers = false;
            state.error = false;
        },
        [moveBackTransfers.rejected]: (state, action) => {
            state.isLoadingMoveBackTransfers = false;
            state.error = true;
        },
        [moveUpdateTransfers.pending]: (state, action) => {
            state.isLoadingMoveUpdateTransfers = true;
            state.error = false;
        },
        [moveUpdateTransfers.fulfilled]: (state, action) => {
            state.isLoadingMoveUpdateTransfers = false;
            state.error = false;
        },
        [moveUpdateTransfers.rejected]: (state, action) => {
            state.isLoadingMoveUpdateTransfers = false;
            state.error = true;
        },
        [deleteSimulationById.pending]: (state, action) => {
            state.isLoadingDeleteSimulationById = true;
            state.error = false;
        },
        [deleteSimulationById.fulfilled]: (state, action) => {
            state.isLoadingDeleteSimulationById = false;
            state.error = false;
        },
        [deleteSimulationById.rejected]: (state, action) => {
            state.isLoadingDeleteSimulationById = false;
            state.error = true;
        },
        [logoutUser.fulfilled]: (state) => {
            return initialState;
        },
        [logoutUser.rejected]: (state) => {
            return initialState;
        },
    }
});

export const getError = (state) => state.nycha.error;
export const getSelectedClientAndLocationResources = (state) => state.nycha.selectedClientAndLocationResources;
export const getIsLoadingHouseAllocation = (state) => state.nycha.isLoadingHouseAllocation;
export const getAllocatedData = (state) => state.nycha.allocatedData;
export const getIsLoadingAllSimulations = (state) => state.nycha.isLoadingAllSimulations;
export const getAllSimulationsData = (state) => state.nycha.allSimulations;
export const getIsLoadingSimulationById = (state) => state.nycha.isLoadingGetSimulationById;
export const getIsLoadingAssignTransfers = (state) =>state.nycha.isLoadingAssignTransfers;
export const getIsLoadingUnAssignTransfers = (state)=>state.nycha.isLoadingUnAssingTransfers
export const getIsLoadingGetLocationsForSimulationCalendar = (state)=>state.nycha.isLoadingGetLocationsForSimulationCalendar;
export const getIsLoadingAcceptTransfers = (state)=>state.nycha.isLoadingAcceptTransfers;
export const getIsLoadingMoveOutTransfers = (state)=>state.nycha.isLoadingMoveOutTransfers;
export const getIsLoadingMoveBackTransfers = (state)=>state.nycha.isLoadingMoveBackTransfers;
export const getIsLoadingMoveUpdateTransfers = (state)=>state.nycha.isLoadingMoveUpdateTransfers;
export const getIsLoadingDelemteSimulationById = (state)=>state.nycha.isLoadingDeleteSimulationById
export const getLocationsDataForSimulationCalendar = (state)=>state.nycha.locationsForSimulationCalendar

export const { storeNychaResources, clearNychaResources, storeNychaResourcesFromSimulation } = nychaSlice.actions;

export default nychaSlice;

